import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";
import { FEATURE_NAMES } from "../../MVC/rolesHelper";
import AlertNotification from "../Notifications/AlertNotification";

/**
 * UserPasswordChangeModal - A component for upgrading space
 */
class SpaceUpgradeModal {
  template() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="make-space-premium-question">
      ${$trans('make-space-premium-question')}
    </div>
    
    <div class="confirm-footer my-5">
      <button class="buttn secondary upgrade-space-modal__cancel" data-lang="cancel-text">
        ${$trans('cancel-text')}
      </button>
      
      <button class="buttn primary upgrade-space-modal__confirm" data-lang="ok-text">
        ${$trans('ok-text')}
      </button>
    </div>
    
    <div class="space-select-modal__differences-question" data-lang="space-select-differences-question" data-show-actions="false">
      ${$trans('space-select-differences-question')}
    <div
  </div>
</div>
    `
  }

  ///constructor
  constructor({ onConfirm = () => {} } = {}) {
    this.onConfirm = onConfirm

    this.render()
    this.addEventListeners()
  }
  ///render
  render() {
    this.$modal = $(this.template());
    $('body').append(this.$modal);
  }

  addEventListeners() {
    this.$modal.find('.confirm-close').on('click', () => {
      this.hide()
    })

    this.$modal.find('.upgrade-space-modal__cancel').on('click', () => {
      this.hide()
    })

    this.$modal.find('.upgrade-space-modal__confirm').on('click', () => {
      this.hide()
      typeof this.onConfirm === 'function' && this.onConfirm()
    })
  }

  show(onConfirm = () => {}) {
    this.onConfirm = onConfirm
    this.$modal.addClass('visible').show();
  }

  hide() {
    this.$modal.removeClass('visible').hide();
  }
}

export default SpaceUpgradeModal;
